import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayerComponent } from './layer.component';
import { LayerService } from './layer.service';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LayerComponent],
  exports: [LayerComponent],
  providers: [LayerService]
})
export class LayerModule { }
